module.exports = __webpack_public_path__ + "img/hand-point-up-WfBNyZU.svg";